import { CarouselPreviousArrow, RightArrow } from "assets/icons";
import Button from "components/BaseWidgets/button";
import Carousel from "components/BaseWidgets/carousel";
import EmptyState from "components/BaseWidgets/emptyState";
import Tag from "components/BaseWidgets/tag";
import Skeleton from "components/BaseWidgets/skeleton";
import { useRef, useState,useEffect } from "react";
import "./style.scss";
function OverViewCarousal({
  cardTitle,
  cardDesc,
  tagLabel,
  cardTitleIcon,
  renderItem,
  carousalData,
  carousalResponsive,
  slidesToShow = 2,
  carousalClass,
  seeAllBtn,
  href,
  isLoading = false,
  seeAllClick,
  autoplaySpeed,
  autoplay,
  infinite,
}) {
  const carouselRef = useRef(null);
  const [visibleSlides, setVisibleSlides] = useState(slidesToShow);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (!carousalResponsive) {
        setVisibleSlides(slidesToShow);
        return;
      }

      const sortedBreakpoints = [...carousalResponsive].sort(
        (a, b) => a.breakpoint - b.breakpoint,
      );
      const matchingBreakpoint = sortedBreakpoints.find(
        (bp) => window.innerWidth < bp.breakpoint,
      );

      setVisibleSlides(
        matchingBreakpoint
          ? matchingBreakpoint.settings.slidesToShow
          : slidesToShow,
      );
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [carousalResponsive, slidesToShow]);

  const isPrevDisabled = currentSlide === 0;
  // Use a small epsilon for floating point comparisons if needed, though usually >= is fine
  const isNextDisabled =
    carousalData && currentSlide + visibleSlides >= carousalData.length;
  const [hasReachedEnd, setHasReachedEnd] = useState(false);

  const handlePrev = () => {
    carouselRef.current?.prev();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  return (
    <div className="overview-block">
      <div className="title-head profile-slider-wrapper">
        <div className="title-text">
          <div className="main-head flex gap-2-5 flex-wrap">
            {cardTitleIcon && (
              <span className="icons-wrapper">{cardTitleIcon}</span>
            )}
            <h3 className="font-title-lg fw-700">{cardTitle}</h3>
            {tagLabel &&
              Array.isArray(carousalData) &&
              carousalData.length > 0 && (
                <Tag readOnly variant="timer" color="yellow">
                  {tagLabel}
                </Tag>
              )}
          </div>

          <div className="flex justify-between items-center mt-1 gap-2">
            <p className="font-title-xs fw-500">{cardDesc}</p>

            <div className="flex items-center gap-8">
              {carousalData?.length > 0 && (
                <>
                  <div
                    className={`flex items-center gap-3 arrow-container 
                      ${seeAllBtn ? "with-reserved-space" : ""}`}
                  >
                    <Button
                      variant="custom"
                      onClick={handlePrev}
                      isDisabled={isPrevDisabled}
                      className={`custom-arrow custom-prev-arrow ${isPrevDisabled ? "disabled" : ""}`}
                    >
                      <CarouselPreviousArrow />
                    </Button>
                    <Button
                      variant="custom"
                      onClick={handleNext}
                      isDisabled={isNextDisabled}
                      className={`custom-arrow custom-next-arrow ${isNextDisabled ? "disabled" : ""}`}
                    >
                      <CarouselPreviousArrow />
                    </Button>
                  </div>
                </>
              )}
              {seeAllBtn && (
                <div className="with-reserved-space">
                  {carousalData?.length > 0 && (seeAllBtn || hasReachedEnd) && (
                    <div className="card-direction">
                      <Button
                        href={href}
                        onClick={seeAllClick}
                        icon={<RightArrow />}
                        className="see-all-btn"
                        variant="custom"
                      >
                        See all
                      </Button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6">
        {isLoading ? (
          <Skeleton label={false} height={248} />
        ) : carousalData?.length === 0 || !carousalData ? (
          <EmptyState className="overview-empty" />
        ) : (
          <Carousel
            ref={carouselRef}
            slidesToShow={slidesToShow}
            slides={Array.isArray(carousalData) ? carousalData : []}
            renderItem={renderItem}
            responsive={carousalResponsive}
            className={carousalClass}
            draggable={seeAllBtn || hasReachedEnd}
            afterChange={(index) => {
              setCurrentSlide(index);
              if (seeAllBtn) {
                const isAtEnd = index + visibleSlides >= carousalData?.length;
                setHasReachedEnd(isAtEnd);
              }
            }}
            autoplaySpeed={autoplaySpeed ? autoplaySpeed : null}
            autoplay={autoplay ? autoplay : null}
            infinite={infinite}
          />
        )}
      </div>
    </div>
  );
}

export default OverViewCarousal;
